export default "__VITE_ASSET__CRRvovoe__"